import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import "moment/locale/id";
import { getListKategoriJson } from "stores/Pengajuan/function";

function Step2() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const listJson = pengajuan.getListKategoriJson;

  Moment.locale("id");
  const tglLahirPasangan = Moment(valDetail.stepDua.tglLahirPasangan).format(
    "DD MMMM YYYY",
  );

  const getLabel = (category, value) => {
    // Cek kalau master datanya ada
    const dataMaster = listJson && listJson[category];
    if (dataMaster && Array.isArray(dataMaster)) {
      const item = dataMaster.find((d) => String(d.value) === String(value));
      return item ? item.label : value || "-";
    }
    return value || "-";
  };

  // KOMPONEN UI: Info Item agar konsisten
  const InfoItem = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted fw-bold mb-1 d-block"
        style={{
          fontSize: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </label>
      <div
        className={`p-2 rounded ${isPrimary ? "bg-light border" : ""}`}
        style={{
          fontSize: "14px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
          minHeight: "38px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  React.useEffect(() => {
    if (!listJson) {
      getListKategoriJson(dispatch);
    }
  }, [dispatch, listJson]);

  return (
    <Row className="mt-3">
      <Col md="12">
        <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
          <Card.Body className="p-4">
            <div
              style={{
                maxHeight: "550px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="custom-scrollbar pr-2"
            >
              <Row>
                {/* --- SEKSI 1: IDENTITAS PASANGAN --- */}
                <Col md={12} className="mb-3 mt-2">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Identitas Pasangan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Nama Pasangan"
                  value={valDetail.stepDua.namaPasangan}
                  isPrimary
                />
                <InfoItem
                  label="Nomor Identitas (KTP)"
                  value={valDetail.stepDua.noKtpPasangan}
                  isPrimary
                />
                <InfoItem label="Tanggal Lahir" value={tglLahirPasangan} />
                <InfoItem
                  label="Nomor Handphone"
                  value={valDetail.stepDua.noHpPasangan}
                  color="#116D6E"
                />
                <InfoItem
                  label="Alamat Pasangan"
                  value={valDetail.stepDua.alamatPasangan}
                  col={12}
                />

                {/* --- SEKSI 2: INFORMASI PEKERJAAN PASANGAN --- */}
                <Col md={12} className="mb-3 mt-4">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Informasi Pekerjaan Pasangan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Status Bekerja"
                  value={getLabel(
                    "statusBekerja",
                    valDetail.stepDua.sedangBekerja,
                  )}
                />
                <InfoItem
                  label="NIP Pasangan"
                  value={valDetail.stepDua.nipPasangan}
                />
                <InfoItem
                  label="NPWP Pasangan"
                  value={valDetail.stepDua.npwpPasangan}
                />
                <InfoItem
                  label="Nama Pekerjaan"
                  value={valDetail.stepDua.namaPekerjaan}
                />
                <InfoItem
                  label="Nama Instansi"
                  value={valDetail.stepDua.namaInstansi}
                />
                <InfoItem
                  label="Pangkat / Golongan"
                  value={valDetail.stepDua.pangkatGolongan}
                />
                <InfoItem label="Jabatan" value={valDetail.stepDua.jabatan} />
                <InfoItem
                  label="Awal Bekerja"
                  value={valDetail.stepDua.awalBekerja}
                />
                <InfoItem
                  label="Alamat Pekerjaan"
                  value={valDetail.stepDua.alamatPekerjaan}
                  col={12}
                />

                <Col md={12} className="mt-2">
                  <Row>
                    <InfoItem
                      label="Telepon Kantor"
                      value={valDetail.stepDua.telpKantor}
                    />
                    <InfoItem
                      label="Alamat Kantor"
                      value={valDetail.stepDua.alamatKantor}
                    />
                  </Row>
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
        .fw-800 { font-weight: 800; }
      `}</style>
    </Row>
  );
}

export default Step2;
